import { mapProducts, normalizeProductRows, productExclude, productSelection } from 'adaptors/campaign/save.adaptor';
function hasExcludesData(campaign) {

  try{
var result=productExclude[campaign.auctionTypeProductExclude];
    switch(result){
      case 'collection':
        return campaign.auctionCollections.some(c=>c.isExclude);
      case 'vendor':
        return campaign.auctionVendors.some(c=>c.isExclude);
      case 'product_type':
        return campaign.auctionProductTypes.some(c=>c.isExclude);
      case 'specific_product':
        return campaign.auctionProducts.some(c=>c.isExclude);
      case 'tag':
        return campaign.auctionTags.some(c=>c.isExclude);
      case 'price_range':
        return campaign.auctionPriceRanges.some(c=>c.isExclude);
      default:
        return false;
    }
  }catch(e){
    return false;
  }
}
export function sendEstimateAdaptor(campaign) {
  const data = {
    isImmediately: true,
    name: 'string',
    type: 'general',
    productInclusionType: productSelection[campaign.auctionTypeProductSelection],
    productExclusionType: hasExcludesData(campaign)?productExclude[campaign.auctionTypeProductExclude]:'none',
    generalDiscountType: 'percentage',
    generalDiscountValue: 1,
    generalDiscountPriceChangeMode: 'price_discounted_into_compare',
    generalDiscountHandleCompareAtPrice: true,
    generalDiscountCustomCent: null,
    autoUpdateIncluded: false,
    autoUpdateExcluded: false,
    tiers: [],
    collections: campaign.auctionCollections.map((c) => ({
      collectionId: parseInt(c.collectionId),
      isExcluded: c.isExclude,
      meta: { title: c.title },
    })),
    vendors: campaign.auctionVendors.map((t) => ({
      vendorName: t.vendorId,
      isExcluded: t.isExclude,
    })),
    productTypes: campaign.auctionProductTypes.map((t) => ({
      productTypeName: t.productTypeName,
      isExcluded: t.isExclude,
    })),
    products: mapProducts(normalizeProductRows(campaign.auctionProducts)),
    tags: campaign.auctionTags.map((t) => ({ tagName: t.tagName, isExcluded: t.isExclude })),
    priceRanges: campaign.auctionPriceRanges.map((t) => ({
      fromPrice: parseFloat(t.fromPrice),
      toPrice: parseFloat(t.toPrice),
      isExcluded: t.isExclude,
    })),
    variantMetafieldRules: (campaign.auctionVariantMetafieldRules ?? []).map((r) => ({
      namespace: r.namespace,
      key: r.key,
      name: r.name,
      type: r.type,
      operator: r.operator,
      value: r.value != null ? String(r.value) : '',
    })),
    variantMetafieldMatchType: campaign.variantMetafieldMatchType ?? 'all',
    isReview: campaign.isReview,
  };

  return data;
}

export function resultEstimateAdaptor(res) {
  const response = {
    status: res.status === 'done' ? 1 : 0,
    success: true,
    variantCount: res?.totalVariants || 0,
    data: res.data.map((p) => ({
      productId: p?.id?.toString(),
      productTitle: p.title,
      productSku: p?.variants[0]?.sku,
      variantCount: p?.variants?.length,
      imageUrl: p?.images[0]?.src,
      handle: p?.handle,
      productLink: '',
      variants: p?.variants || [],
    })),
  };
  return response;
}
